var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3483 0.5H1.65335C1.38184 0.500214 1.11623 0.57923 0.888761 0.727459C0.661287 0.875688 0.481728 1.08676 0.371877 1.33505C0.262025 1.58334 0.226603 1.85818 0.269911 2.12621C0.313218 2.39424 0.433393 2.64394 0.61585 2.845L5.25085 7.9425V12.75C5.25089 12.844 5.27741 12.936 5.32738 13.0156C5.37735 13.0952 5.44873 13.1591 5.53335 13.2C5.60098 13.2333 5.67545 13.2505 5.75085 13.25C5.86449 13.2499 5.97471 13.2111 6.06335 13.14L7.00085 12.39L8.56335 11.14C8.62182 11.0932 8.66902 11.0338 8.70148 10.9663C8.73393 10.8988 8.7508 10.8249 8.75085 10.75V7.9425L13.3858 2.845C13.5683 2.64394 13.6885 2.39424 13.7318 2.12621C13.7751 1.85818 13.7397 1.58334 13.6298 1.33505C13.52 1.08676 13.3404 0.875688 13.1129 0.727459C12.8855 0.57923 12.6199 0.500214 12.3483 0.5Z",
    fill: "#318BEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFilterIcon);
export default __webpack_public_path__ + "static/media/table-filter-icon.aacf27a4453b9ca5befdf10dbbd24bee.svg";
export { ForwardRef as ReactComponent };